import { Suspense, useEffect, useState } from 'react';

import { Group } from '@mantine/core';

import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import { Loader } from '../../../../../shared/components/UI/Loader/Loader';

import { Tabs } from './tabs/tabs';

interface Tab {
  id: string;
  label: string;
  path: string;
  component: React.ReactNode;
}

interface VaultTabsProps {
  tabs: Tab[];
}

export function VaultTabs({ tabs }: VaultTabsProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function getActiveTabIdFromPathname() {
    const tabId = tabs.find(tab => matchPath(tab.path, pathname))?.id;
    if (tabId) {
      return tabId;
    }
    return tabs[0].id;
  }

  const [activeTabId, setActiveTabId] = useState<string>(
    getActiveTabIdFromPathname(),
  );

  function handleTabChange(tabId: string) {
    setActiveTabId(tabId);
    navigate(tabs.find(tab => tab.id === tabId)?.path ?? '/');
  }

  useEffect(() => {
    const tabId = getActiveTabIdFromPathname();
    navigate(`/response/vault/${tabId}`);
    setActiveTabId(tabId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, tabs]);

  return (
    <>
      <Group w={'100%'} position="apart" align="center">
        <Tabs
          activeTabId={activeTabId}
          onTabChange={handleTabChange}
          tabs={tabs.map(tab => ({
            id: tab.id,
            label: tab.label,
            path: tab.path,
          }))}
        />
      </Group>
      <Suspense fallback={<Loader />}>
        {tabs.find(tab => tab.id === activeTabId)?.component}
      </Suspense>
    </>
  );
}
